/**
 * Design System
 *
 * The kitchen sink of all design components. Essentially, we build up a
 * `components` object that is exported that contains every component in our
 * design system that should be available.
 *
 * There is a little bit of "magic" below, so be sure to read each section.
 *
 * If you prefer NO MAGIC, then simply modify this file so that you import each
 * component manually, and provide keys to the `components` module, ie.
 *
 */

import * as forms from './_patterns/01-atoms/forms';
import * as select from './_patterns/01-atoms/forms/select';
import * as textfields from './_patterns/01-atoms/forms/textfields';
import * as dropzone from './_patterns/02-molecules/dropzone';

export const webformsComponents = {
  forms,
  select,
  textfields,
  dropzone,
};

/**
 * All component names as an array
 * @returns {Array} List of components name strings
 */
export const componentNames = () =>
  Object.values(webformsComponents).map(({ name }) => name);

/**
 * Enable all components against a piece of DOM with some settings
 */
export const enableWebformsComponents = ($dom, settings) =>
  Object.values(webformsComponents).forEach(({ enable }) =>
    enable($dom, settings)
  );

export default webformsComponents;
